import {useRef} from 'react';
import {defineMessages, useIntl} from 'react-intl';
import {view, Tooltip, Icon, Link} from '@sail/ui';
import {info} from '@sail/icons/react/Icon';
import {dotComColors} from '../theme';

const messages = defineMessages({
  disclaimer: {
    id: 'conversations_ui.conversation.aiDisclaimer.disclaimer',
    description: 'AI Disclaimer message',
    defaultMessage: 'By chatting, you agree to this disclaimer.',
  },
  privacyPolicy: {
    id: 'conversations_ui.conversation.aiDisclaimer.privacyPolicy',
    description: 'Privacy policy',
    defaultMessage: 'privacy policy',
  },
  howStripeUsesAI: {
    id: 'conversations_ui.conversation.aiDisclaimer.howStripeUsesAI',
    description: 'How Stripe uses AI',
    defaultMessage: 'how Stripe uses AI',
  },
  hoverState: {
    id: 'conversations_ui.conversation.aiDisclaimer.hoverState',
    description: 'AI Disclaimer hover state',
    defaultMessage:
      'By chatting, you acknowledge that Stripe will handle your data pursuant to our {privacyPolicyLink}, and that you understand {aiLink}.',
  },
});

export const AIDisclaimer = () => {
  const {formatMessage} = useIntl();
  const ref = useRef(null);

  return (
    <view.div
      ref={ref}
      css={{
        marginBottom: '8px',
        height: '25px',
        fontSize: '13px',
        weight: 400,
        textAlign: 'center',
        color: dotComColors.brand800,
        flex: 0,
      }}
    >
      <view.div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        {formatMessage(messages.disclaimer)}
        <Icon icon={info} style={{paddingLeft: '4px'}} size="small" />
      </view.div>
      <Tooltip
        trigger={ref}
        css={{
          maxWidth: 'calc(100% - 32px)',
          marginLeft: '12px',
          fontSize: '13px',
          color: '#364657',
          padding: '8px 16px',
          boxShadow: 'unset',
        }}
      >
        {formatMessage(messages.hoverState, {
          privacyPolicyLink: (
            <Link
              css={{
                color: dotComColors.brandButton,
                ':hover': {
                  color: '#0a2540',
                },
              }}
              href="https://stripe.com/privacy"
              target="_blank"
              rel="noreferrer"
            >
              {formatMessage(messages.privacyPolicy)}
            </Link>
          ),
          aiLink: (
            <Link
              css={{
                color: dotComColors.brandButton,
                ':hover': {
                  color: '#0a2540',
                },
              }}
              href="https://support.stripe.com/questions/use-of-artificial-intelligence-(ai)-in-stripe-services"
              target="_blank"
              rel="noreferrer"
            >
              {formatMessage(messages.howStripeUsesAI)}
            </Link>
          ),
        })}
      </Tooltip>
    </view.div>
  );
};
